import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import BottomFooter from './BottomFooter';
import TopFooter from './TopFooter';
import { setFormsLanguage } from '../../../redux/modules/global';
import useIsHomePage from '../../../hooks/useIsHomePage';

import useStyles from './makeStyles';

const EfesFooter = () => {
  const isHomePage = useIsHomePage();
  const classes = useStyles();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const handleChangeLanguage = useCallback(
    (language) => {
      i18n.changeLanguage(language);
      dispatch(setFormsLanguage(language));
    },
    [dispatch, i18n],
  );

  return (
    <div className={classes.contentViewPort}>
      <div className={classes.contentContainer}>
        {isHomePage && (
          <TopFooter handleChangeLanguage={handleChangeLanguage} language={i18n.language} />
        )}
      </div>
      <div className={classes.divider} />
      <div className={classes.contentContainer}>
        <BottomFooter handleChangeLanguage={handleChangeLanguage} language={i18n.language} />
      </div>
    </div>
  );
};

export default EfesFooter;
